﻿import {DependencyList, useEffect} from "react";

const useScrollPassive = (onScrollCallback: () => void, deps: DependencyList) => {
  useEffect(() => {
    window.addEventListener('scroll', onScrollCallback, { passive: true });

    return () => {
      window.removeEventListener('scroll', onScrollCallback);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onScrollCallback, ...deps]);
}

export { useScrollPassive };
